// Inject a Cloudinary delivery transformation into an uploaded asset's URL.
// Every upload's `secure_url` looks like
//   https://res.cloudinary.com/<cloud>/image/upload/v<version>/<path>
// and Cloudinary applies transforms inserted right after `/image/upload/`.
//
// We do this client-side so the same DB row can be re-rendered with new
// transformation params without a re-upload or migration.
export function withCloudinaryTransform(url: string, transform: string): string {
  return url.replace("/image/upload/", `/image/upload/${transform}/`);
}
